import BankingApp from "./BankingApp";

const Index = () => <BankingApp />;

export default Index;